var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('center-nav',{ref:"centerNav",on:{"getBuySeatIndex":_vm.getBuySeat}}),_vm._v(" "),(_vm.seatNum > 0 && _vm.openAppList.length > 0)?_c('slider-menu',{attrs:{"menuData":_vm.menuData}}):_vm._e(),_vm._v(" "),(_vm.seatNum === 0)?_c('creditCard'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a9876a5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pc/channelMiniProgram/index.vue
// module id = null
// module chunks = 